export const pathName = {
  myReservations: "/myReservations",
  allReservations: "/allReservations",
  myCabins: "/myCabins",
  addEmployee: "/addEmployee",
};
